import OperatorUsersPage from "./OperatorUsersPage";

const module = {
    routeProps : {
        path: 'OperatorUsers',
        component: OperatorUsersPage
    },

    name: " Operator Users",
    label: "Operator Users",
    title: "Operator Users",
    showOnMenu: true
}

export default module;